export const PROVIDER_OPTIONS = [
  { value: "dabom", label: "dabom" },
  { value: "peachgrove", label: "peachgrove" },
  { value: "morelogin", label: "morelogin" },
  { value: "sg", label: "sg" },
];
